export default options => ({ dispatch }) => next =>
  function(action) {
    const { payload } = action
    const payloadIsPromise = payload && typeof payload.then === 'function'
    const payloadHasPromise =
      payload && payload.promise && typeof payload.promise.then === 'function'
    if (!payloadIsPromise && !payloadHasPromise) {
      return next(action)
    }

    const createAction = (suffix, originalPayload, extraAttributes = {}) => {
      const meta = extraAttributes.meta
        ? Object.assign({}, { action }, extraAttributes.meta)
        : { action }

      const payload = extraAttributes.payload
        ? Object.assign({}, originalPayload, extraAttributes.payload)
        : originalPayload

      return {
        type: `${action.type}_${suffix}`,
        meta,
        payload,
      }
    }

    const extraActionAttributes =
      (action.meta &&
        action.meta.promise &&
        action.meta.promise.extraActionAttributes) ||
      {}

    const startPayload = payload.promise ? payload : null
    next(createAction('START', startPayload, extraActionAttributes.start))

    const payloadPromise = payload.promise || payload
    return payloadPromise.then(
      value =>
        dispatch(createAction('SUCCESS', value, extraActionAttributes.success)),
      error =>
        dispatch(createAction('ERROR', error, extraActionAttributes.error))
    )
  }
